import { memo } from "react";
import { Product } from "../../../../interfaces/domain/menu";
import { PlateInfo } from "../PlateInfo";
import { useMainPlate } from "../../../../hooks/useMainPlate";
import { getAssetUrl } from "../../../../utils/getAssetUrl";
import { useOrdersStore, useUIStore } from "../../../../store";
import { ProductImage } from "../../../atoms";
import { useCartQuantity } from "../../../../hooks/useCartQuantity";
import styles from "./MainPlate.module.scss";

interface Props {
  plate: Product;
}

const MainPlate = memo(({ plate }: Props) => {
  const { openModal, handleKeyDown } = useMainPlate(plate);
  const config = useUIStore((s) => s.config);
  const canUseCart = useOrdersStore((s) => s.canUseCart);
  const src = getAssetUrl(plate.image_url, config);
  const quantityInCart = useCartQuantity(plate.id);

  return (
    <div
      className={styles.card}
      onClick={openModal}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`Ver detalles de ${plate.title}`}
    >
      <ProductImage
        src={src}
        alt={plate.title}
        showPlaceholder={true}
        config={config}
        wrapperClassName={styles.imageWrapper}
        loading="eager"
      >
        <button
          onClick={(e) => { e.stopPropagation(); openModal(); }}
          className={styles.addButton}
        >
          {canUseCart ? (
            quantityInCart > 0 ? (
              <span className={styles.quantity}>{quantityInCart}</span>
            ) : (
              <span className={styles.add}>+</span>
            )
          ) : (
            <span className={styles.viewmore}>Ver +</span>
          )}
        </button>
      </ProductImage>

      <PlateInfo plate={plate} section="mainPlate" onOpenModal={openModal} />
    </div>
  );
});

export default MainPlate;
